import React from 'react';
import '../LandingPage/LandingPage.css';
import Footer from '../../Components/Footer/Footer';
import header from '../../Components/Header/Header.module.css';
import Header from '../../Components/Header/Header';
import soon from './Soon.module.css'


const Soon: React.FC = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth' // Optional: Adds a smooth scrolling animation
  });
  return (
    <div className='generalPage'>
      <div className='landingPage'>
        <div className={header.headerContainer}>
          <Header />
        </div>
        <div className={soon.sentBody}>
            <h2>
                More Information Coming Soon!
            </h2>
        </div>
      </div>
      <Footer />
      
    </div>

  );
};

export default Soon;